import React from 'react';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import { SERVICE_CHAIN, SERVICE_FLEET, SERVICE_WORKSHOP } from '../../utils/utils';

export const NOTIFICATION_SETTINGS_PATHS = {
  [SERVICE_FLEET]: '/settings/notifications',
  [SERVICE_WORKSHOP]: '/workshop-settings/notifications',
  [SERVICE_CHAIN]: '/chain-settings/notifications',
};

// Replaces the old per-page "Vastaanota ilmoituksia" switches: e-mail
// notifications are managed on one page now.
const NotificationSettingsLink = ({ t, service, style }) => {
  const path = NOTIFICATION_SETTINGS_PATHS[service];
  if (!path) {
    return null;
  }
  return (
    <p style={{ margin: 0, fontSize: 14, color: '#fff', ...style }}>
      <i className='pi pi-bell' style={{ marginRight: 8, fontSize: 13 }} />
      {t('emailNotificationsManagedOn')}
      {' '}
      <Link to={path} style={{ color: '#fff', textDecoration: 'underline' }}>
        {t('openNotificationSettings')}
      </Link>
    </p>
  );
};

export default translate('NotificationSettings')(NotificationSettingsLink);
